import styled from '@emotion/styled'
import { themeColor } from 'utils/styles'

export const OutputSectionContainer = styled('div')`
  font-size: 11px;
  padding-left: 10px;
  color: ${themeColor('blackSecondary')};

  & .output-container {
    margin-top: 55px;
  }
`
